import type { HomePageVariant } from '@/interface/home-pages';

export const HOME_PAGES_V4 = { key: 'home-v4', cta: 'assine', visual: 'v23' } as const satisfies HomePageVariant;
